var map = {
	"./symbol_0.png": "65ff",
	"./symbol_1.png": "b5ff",
	"./symbol_2.png": "f22c",
	"./symbol_3.png": "e001",
	"./symbol_4.png": "e8b4",
	"./symbol_5.png": "0c3c",
	"./symbol_6.png": "4a7a",
	"./symbol_7.png": "a25d"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "8ca4";